<template>
    <Head>
        <title>Error</title>
    </Head>
    <div class="app">
        <div class="wrapper">
            <slot />
        </div>
    </div>
</template>

<script setup>
</script>

<style lang="scss" scoped>
.app {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    overflow-y: auto;
    padding: 50px;
    color: #0a111a;

    .wrapper {
        width: 90%;
        margin: 0 auto;
    }
}
</style>
